import { PreQualificationStatus } from '@ekhodealer/ekho-common';
import { ContentWithTooltip } from '@ekhodealer/ekho-common/rev';

import { PrequalIcon } from './PrequalIcon';

interface PrequalBadgeProps {
	status: PreQualificationStatus | undefined;
}

const getTooltipText = (status: PreQualificationStatus | undefined): string => {
	switch (status) {
		case PreQualificationStatus.PRE_QUALIFIED:
			return 'Successfully pre-qualified';
		case PreQualificationStatus.REJECTED:
			return 'Failed pre-qualification';
		default:
			return 'Pre-qual not attempted';
	}
};

export const PrequalBadge = ({ status }: PrequalBadgeProps) => (
	<ContentWithTooltip
		content={<PrequalIcon status={status} />}
		tooltipContent={getTooltipText(status)}
	/>
);
